import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef} from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//components
import {FullServicePricingCustomerPackageEditComponent} from '../../components/Editors/FullServicePricingCustomerPackageEdit.component';
import {FullServiceCustomerGridComponent} from '../../components/Grids/FullServiceCustomerGrid.component';
import {SalesOfficeMultiSelectComponent} from '../../components/DomainData/SalesOfficeMultiSelect.component';
import {CustomersAutoCompleteComponent} from '../../components/Customers/CustomersAutoComplete.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { PackageConfig } from '../../entities/index';


@Component({
  selector: 'my-fullservicepricingdetails',
  templateUrl: './FullServicePricingDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => FullServicePricingDetailsComponent)}]
})
export class FullServicePricingDetailsComponent extends BaseControlGroupComponent {

    
    @ViewChild(SalesOfficeMultiSelectComponent) salesOfficeMultiSelectComponent: SalesOfficeMultiSelectComponent;
    @ViewChild(FullServiceCustomerGridComponent) public fullServiceCustomerGridComponent: FullServiceCustomerGridComponent;
    @ViewChild(CustomersAutoCompleteComponent) public customersAutoCompleteComponent: CustomersAutoCompleteComponent;
    @ViewChild(FullServicePricingCustomerPackageEditComponent) public fullServicePricingCustomerPackageEditComponent: FullServicePricingCustomerPackageEditComponent;

    fullServicePricingForm: FormGroup;
    fullServicePricingInfo: ent.FullServicePricingInfo = new ent.FullServicePricingInfo();
    vendPackages: ent.VendPackage[] = [];
    fullServicePricingLineItems: ent.FullServicePricingLineItem[] = [];
    fullServiceCustomer: ent.FullServiceCustomer;

    
    
    @Input() public requestTypeID: number;
    
    setRequestInfo(request: ent.Request){
        this.fullServicePricingInfo = request.FullServicePricingInfo;

        this.fullServicePricingLineItems = request.FullServicePricingLineItems;

        if (this.fullServicePricingInfo.ZQCustomerSalesOfficeID != this.userInfo.SalesOffice.ID){
            this.salesOfficeMultiSelectComponent.selectedIDs.push(this.fullServicePricingInfo.ZQCustomerSalesOfficeID);
        }

        this.customersAutoCompleteComponent.salesOfficeIDs = this.salesOfficeMultiSelectComponent.selectedIDs;
        this.loadCustomers(this.fullServicePricingInfo.ZQCustomerNumber);
        
    }

    loadSalesOffices(idsToSelectOnLoad: number[]): Promise<any> {
        
        this.salesOfficeMultiSelectComponent.SalesOffices = [];

        return new Promise((resolve) => { 
            this.salesOfficeMultiSelectComponent.IDsToSelectOnLoad = idsToSelectOnLoad;
            this.salesOfficeMultiSelectComponent.load();

        });
        
        
    }

    salesOfficeIDsChange(event: any){
        this.customersAutoCompleteComponent.salesOfficeIDs = this.salesOfficeMultiSelectComponent.selectedIDs;
    }
    
    setDates(){
        this.fullServicePricingInfo.EffectiveDate = util.DateUtil.ConvertDateToJS(this.fullServicePricingInfo.EffectiveDate);
    }
    
    constructor(fb: FormBuilder, private customerService: serv.CustomerService) 
    { 
        super();
        this.fullServicePricingInfo = new ent.FullServicePricingInfo();
        
        let group = {
            'zqCustomerNumber' : '',
            'zqCustomerName' : '',
            'customerAutoSelect' : '',
            'effectiveDate' : '',
            'needsReview' : ''
        };
        
        this.fullServicePricingForm = fb.group(group);

    }

    ngOnInit(): void {
        this.fullServicePricingForm.controls['effectiveDate'].setValidators(Validators.required);

        var today = new Date();
        this.fullServicePricingInfo.EffectiveDate = util.DateUtil.ConvertDateToJS(today);
        this.loadPackages();
        this.loadSalesOffices([this.userInfo.Employee.SalesOfficeID]).then(x=> {
            this.customersAutoCompleteComponent.salesOfficeIDs = this.salesOfficeMultiSelectComponent.selectedIDs;
        });
    }

    public loadPackages(){
        var filter: filters.VendPackageFilter = {IncludePackageConfigs: true};
        this.domainDataService.getVendPackages(filter).subscribe(x=> this.onGetVendPackagesDone(x));
    }
    
    onGetVendPackagesDone(items: ent.VendPackage[]){
        this.vendPackages = items;
        
    }

    selectedCustomerNumbersChanged(customerNumbers: string[]){
        if (customerNumbers && customerNumbers.length > 0){
            var filter: filters.CustomerFilter = {ZQCustomerNumber: customerNumbers[customerNumbers.length - 1]};
            this.customerService.getFullServiceCustomers(filter).subscribe(x=>
            {
                if (x && x.length > 0){
                    this.fullServiceCustomer = x[0];
                    this.fullServicePricingInfo.ZQCustomerNumber = this.fullServiceCustomer.ZQCustomerNumber;
                    this.fullServicePricingInfo.ZQCustomerName = this.fullServiceCustomer.ZQCustomerName;
                    this.fullServicePricingInfo.ZQCustomerSalesOfficeID = this.fullServiceCustomer.SalesOffice.ID;
                    this.loadCustomers(this.fullServicePricingInfo.ZQCustomerNumber);

                    this.checkForNeedsReview();
                }
                else{
                    this.fullServicePricingInfo.ZQCustomerNumber = "";
                    this.fullServicePricingInfo.ZQCustomerName = "";
                    this.fullServicePricingInfo.ZQCustomerSalesOfficeID = 0;
                }
                
            });
        }
        else{
            this.fullServicePricingInfo.ZQCustomerNumber = "";
            this.fullServicePricingInfo.ZQCustomerName = "";
            this.fullServicePricingInfo.ZQCustomerSalesOfficeID = 0;
        }

    }

    checkForNeedsReview(){
        var needsReview: boolean = false;

        if (this.fullServiceCustomer.SalesOffice.ID != this.userInfo.SalesOffice.ID){
            needsReview = true;
        }

        for (var item of this.fullServicePricingLineItems){
            
            if (item.PackageConfig.PerformanceBasedPay == true || item.PricingTypeID == enums.FullServicePricingTypeEnum.Contract){
                needsReview = true;
            }

            if (item.PricingTypeID == enums.FullServicePricingTypeEnum.TierOnGrid){
                if (item.VendRateAmount < item.PackageConfig.MinimumVendPrice){
                    needsReview = true;    
                }
            }
        }

        this.fullServicePricingInfo.NeedsReview = needsReview;
    }

    loadCustomers(customerNumber: string){
        
        var filter: filters.CustomerFilter = {ZQCustomerNumber: customerNumber, SalesOfficeIDs: this.salesOfficeMultiSelectComponent.selectedIDs };
        this.customerService.getFullServiceCustomers(filter).subscribe(x=>
            {
                for (var item of x){
                    item.Included = true;
                }
                this.fullServiceCustomerGridComponent.lineItems = x;
                
                this.initCustomerCounts();

                this.loadCustomerPackageCounts();
                
            });
    }

    onFullServicePricingCustomerPackageEditOK(event: any){
        this.fullServicePricingCustomerPackageEditComponent.displayDialog = false;

        for (var item of this.fullServicePricingCustomerPackageEditComponent.lineItems){
            _.remove(this.fullServicePricingLineItems, x=>x.CustomerNumber==item.CustomerNumber);
        }

        
        
        for (var item of this.fullServicePricingCustomerPackageEditComponent.lineItems){
            if (this.isFullServicePricingLineItemValid(item)){
                if (item.ApplyToAllCustomers){
                    _.remove(this.fullServicePricingLineItems, x=>x.PackageID==item.PackageID && x.PackageConfig.CustomerTypeID == item.PackageConfig.CustomerTypeID);
                    for (var customer of this.fullServiceCustomerGridComponent.lineItems){
                        if (customer.Included == true){
                            if (item.PackageConfig == undefined){
                                item.PackageConfig = item.VendPackage.PackageConfigs.filter(x=>x.CustomerTypeID == customer.CustomerTypeID)[0];
                            }
                            if (item.PackageConfig != undefined && item.PackageConfig.CustomerTypeID == customer.CustomerTypeID){
                                this.copyLineItem(item, customer);
                            }
                        }
                    }
                }
                else{
                    this.copyLineItem(item, null);
                }
                
            }

        }
        this.initCustomerCounts();
        this.loadCustomerPackageCounts();
        this.checkForNeedsReview();

    }

    isFullServicePricingLineItemValid(item: ent.FullServicePricingLineItem) : boolean{

        var commissionRateValid = (item.CommissionRate != undefined && item.CommissionRate >= 0) || 
            (item.PackageConfig != undefined && item.PackageConfig.PerformanceBasedPay == true);

        var vendPriceValid = item.VendRateAmount && item.VendRateAmount != 0;

        return vendPriceValid;
        //return commissionRateValid && vendPriceValid;
    }

    copyLineItem(item: ent.FullServicePricingLineItem, customer: ent.FullServiceCustomer){
        var lineItem: ent.FullServicePricingLineItem = {VendPackage: item.VendPackage, PackageID: item.VendPackage.ID, 
            PricingTypeID: item.PricingTypeID, FullServicePricingType: item.FullServicePricingType, 
            VendRateAmount: item.VendRateAmount, CommissionRate: item.CommissionRate, PackageConfig: item.PackageConfig, PackageConfigID: item.PackageConfigID, CommissionRateSelectItems: item.CommissionRateSelectItems };

        if (customer != undefined){
            lineItem.CustomerNumber = customer.CustomerNumber;
        }
        else{
            lineItem.CustomerNumber = item.CustomerNumber;
            customer = this.fullServiceCustomerGridComponent.lineItems.filter(x=>x.CustomerNumber == item.CustomerNumber)[0];
        }


        if (lineItem.PackageConfig == undefined){
            lineItem.PackageConfig = lineItem.VendPackage.PackageConfigs.filter(x=>x.CustomerTypeID == customer.CustomerTypeID)[0];
            lineItem.PackageConfigID = lineItem.PackageConfig.ID;
        }
        this.fullServicePricingLineItems = [...this.fullServicePricingLineItems, lineItem];    
    }
    

    initCustomerCounts(){
        for (var customer of this.fullServiceCustomerGridComponent.lineItems){
            customer.UpdatedPackageCount = 0;
        }
    }

    loadCustomerPackageCounts(){
        for (var item of this.fullServicePricingLineItems){
            this.fullServiceCustomerGridComponent.lineItems.filter(x=>x.CustomerNumber == item.CustomerNumber)[0].UpdatedPackageCount += 1;
        }
    }

    onLineItemEditClicked(fullServiceCustomer: ent.FullServiceCustomer)
    {
        this.fullServicePricingCustomerPackageEditComponent.displayDialog = true;

        this.fullServicePricingCustomerPackageEditComponent.lineItems = [];

        this.fullServicePricingCustomerPackageEditComponent.customerTypeID = fullServiceCustomer.CustomerTypeID;
        
        var lineItemsForThisCustomer = this.fullServicePricingLineItems.filter(x=>x.CustomerNumber == fullServiceCustomer.CustomerNumber && x.PackageConfig.CustomerTypeID == fullServiceCustomer.CustomerTypeID);
        for (var vp of this.vendPackages){
            var packageConfigs = vp.PackageConfigs.filter(x=>x.CustomerTypeID == fullServiceCustomer.CustomerTypeID && x.PerformanceBasedPay == true);
            var nonPBPPackageConfig = vp.PackageConfigs.filter(x=>x.CustomerTypeID == fullServiceCustomer.CustomerTypeID && !x.PerformanceBasedPay)[0];
            if (nonPBPPackageConfig != undefined){
                packageConfigs.push(nonPBPPackageConfig);
            }

            for (var packageConfig of packageConfigs){
                var lineItem: ent.FullServicePricingLineItem = {VendPackage: vp, CustomerNumber: fullServiceCustomer.CustomerNumber };
                var lineItemsForThisPackage = lineItemsForThisCustomer.filter(x=>x.PackageID == vp.ID && x.PackageConfig.ID == packageConfig.ID);
                if (lineItemsForThisPackage.length > 0){
                    var firstLineItem = lineItemsForThisPackage[0];
                    lineItem.CommissionRate = firstLineItem.CommissionRate;
                    lineItem.VendRateAmount = firstLineItem.VendRateAmount;
                    lineItem.PricingTypeID = firstLineItem.PricingTypeID;
                    lineItem.FullServicePricingType = firstLineItem.FullServicePricingType;
                    if (firstLineItem.PackageConfig != undefined){
                        lineItem.PackageConfig = firstLineItem.PackageConfig;
                        lineItem.PackageConfigID = firstLineItem.PackageConfigID;
                    }
                    else{
                        lineItem.PackageConfig = packageConfig;
                        lineItem.PackageConfigID = packageConfig.ID;
                    }
                }
                else{
                    //if (packageConfig.PerformanceBasedPay == true){
                        lineItem.PackageConfig = packageConfig;
                        lineItem.PackageConfigID = packageConfig.ID;
                    //}
                }
                
                if (lineItem.CommissionRateSelectItems == null || lineItem.CommissionRateSelectItems.length == 0){
                    lineItem.CommissionRateSelectItems = [];
                
                    lineItem.CommissionRateSelectItems.push({label:"", value:Constants._NONE});
                    
                    if (lineItem.VendPackage && lineItem.VendPackage.PackageConfigs){
                        for (var config of lineItem.VendPackage.PackageConfigs.filter(x=>x.CustomerTypeID == fullServiceCustomer.CustomerTypeID)){
                            if (config.CommissionRate != null && !config.PerformanceBasedPay){
                                lineItem.CommissionRateSelectItems.push({label:config.CommissionRate.toString(), value:config.ID});
                            }
                        }
                    }
                }
                this.fullServicePricingCustomerPackageEditComponent.lineItems = [...this.fullServicePricingCustomerPackageEditComponent.lineItems, lineItem];
            }
        }
    }
}
